import { useEffect, useMemo, useState } from 'react'

import { Accordion, Box, Slider, Text } from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { Card } from '../../../../components/Card/card.comp'
import {
  IItemsStatisticsDTO,
  ItemRawStatisticsDataDTO,
} from '../../../../sdk/traceability/traceability.types'
import { sdk } from '../../../../services/sdk'
import { getOrderCardProps } from '../../origin-invoice.utils'

import { OrderItemProps } from './order-item.types'

export const OrderItem = ({ order }: OrderItemProps) => {
  const [open, setOpen] = useState(false)

  const [orderStatistics, setOrderStatistics] = useState<IItemsStatisticsDTO>()
  const [orderStatisticsData, setOrderStatisticsData] =
    useState<ItemRawStatisticsDataDTO>()

  const handleToggle = () => {
    setOpen(!open)
  }

  const getOrderData = async (orderCode: string) => {
    try {
      const [statisticsResponse, statisticsDataResponse] = await Promise.all([
        sdk.traceability.orderStatistics(orderCode),
        sdk.traceability.orderStatisticsData(orderCode),
      ])

      setOrderStatistics(statisticsResponse)
      setOrderStatisticsData(statisticsDataResponse)
    } catch (err) {}
  }

  useEffect(() => {
    if (open && !orderStatistics) {
      getOrderData(order.code)
    }
  }, [open])

  const cardProps = useMemo(
    () => getOrderCardProps(orderStatistics, orderStatisticsData),
    [orderStatistics, orderStatisticsData],
  )

  const theme = useTheme()

  return (
    <Accordion
      onToggle={handleToggle}
      header={
        <Box gap={5}>
          <Box gap={1} alignItems="center" width="100%">
            <Text size="small" color="grey_3">
              Ordem
            </Text>
            <Text>{order.code}</Text>
          </Box>
        </Box>
      }
    >
      <Box
        backgroundColor="grey_5"
        borderRadius={theme.border_radius.box}
        padding={3}
        direction="column"
      >
        <Slider buttonPosition="side" sizeToScroll={200}>
          {cardProps.map((props, index) => (
            <Card {...props} key={`item-card-${index}`} />
          ))}
        </Slider>
      </Box>
    </Accordion>
  )
}
